import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpAction } from '../studio-http-client/http-action.enum';
import { SchoolAcademicYearResponse } from '../models/school-academic-year-response';
import { Observable } from 'rxjs';
import { SchoolYearReturnModel } from '../models/school-year-return-model';

@Injectable({
  providedIn: 'root',
})
export class AcademicYearService {
  apiService = inject(ApiService);

  getSchoolsAcademicYears(schoolIds: string[]) {
    const url = 'api/Schools/AcademicYears/GetCurrent';
    return this.apiService.invokeLSApi<SchoolAcademicYearResponse[]>(
      url,
      HttpAction.PostWithBodyResponse,
      schoolIds
    );
  }

  getDistrictAcademicYears(customerId: number): Observable<SchoolYearReturnModel[]> {
    const url = `v1/internal/districts/${customerId}/SchoolYears`;
    return this.apiService.invokeMPApi<SchoolYearReturnModel[]>(url, HttpAction.Get);
  }
}
